/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Spanish (es) · Contact page
   English is the source of truth in contact.html; this file supplies the
   Spanish counterpart for each contact.* data-i18n key. Missing keys fall
   back to English automatically (see i18n.js).

   House voice: calm, exact, short. No em dashes (use periods, commas,
   or the mid-dot · ). Product names (Transderma C/A/O/M/R, Discovery
   Kit, Moisture Serum) and the postal address stay as-is. Informal
   singular "tú" throughout.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.es = window.TD_I18N.es || {};
  Object.assign(window.TD_I18N.es, {

    /* ── Footer · extra link not on the homepage ── */
    'footer.learn.about': 'Sobre el Dr. Ronlán',

    /* ── Page head ── */
    'contact.eyebrow': 'Ponte en contacto',
    'contact.title': 'Preguntas,<br>solicitudes,<br><em>o solo un hola.</em>',
    'contact.intro': 'Consultas de prensa, solicitudes de distribuidores, preguntas sobre la rutina o cualquier cosa intermedia. Leemos cada mensaje. Las respuestas suelen llegar en un plazo de dos días laborables.',

    /* ── Reach us ── */
    'contact.reach': 'Cómo encontrarnos',
    'contact.email.label': 'Correo electrónico',
    'contact.email.meta': 'Lo mejor para preguntas detalladas',
    'contact.phone.label': 'Teléfono',
    'contact.phone.meta': 'Lun – vie · 9 h – 17 h EST',
    'contact.address.label': 'Dirección',
    'contact.address.meta': 'Devoluciones y correspondencia',
    'contact.social.label': 'Encuéntranos en redes sociales',

    /* ── Inquiry form ── */
    'contact.form.eyebrow': 'Enviar una consulta',
    'contact.form.name': 'Nombre',
    'contact.form.subject': 'Asunto',
    'contact.form.email': 'Correo electrónico',
    'contact.form.message': 'Mensaje',
    'contact.form.send': 'Enviar',
    'contact.form.success': 'Gracias por escribirnos · te responderemos en 1–2 días laborables.',

    /* ── Response windows ── */
    'contact.hours.eyebrow': 'Tiempos de respuesta',
    'contact.hours.email.label': 'Correo electrónico',
    'contact.hours.email.val': 'En 2 días laborables',
    'contact.hours.phone.label': 'Teléfono',
    'contact.hours.phone.val': '9 h – 17 h EST',
    'contact.hours.press.label': 'Prensa',
    'contact.hours.press.val': 'En 1 día laborable',

    /* ── CTA ── */
    'contact.cta.title': '¿No sabes qué sérum es el adecuado para ti?',
    'contact.cta.body': 'El Discovery Kit contiene versiones de bolsillo de los cinco sérums. La mayoría lo sabe en pocos días.',
    'contact.cta.button': 'Obtener el Discovery Kit'

  });
})();
